/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationQueryTopicsLiveTopicsQueryResponse, NlpIntegrationQueryTopicsLiveTopicsPathParams, NlpIntegrationQueryTopicsLiveTopicsQueryParams, NlpIntegrationQueryTopicsLiveTopics401, NlpIntegrationQueryTopicsLiveTopics403 } from "../models/NlpIntegrationQueryTopicsLiveTopics";

export function getNlpIntegrationQueryTopicsLiveTopicsUrl(slug: NlpIntegrationQueryTopicsLiveTopicsPathParams["slug"]) {
  const res = { method: 'GET', url: `/nlp-integration/v1/live-topics/${slug}/topics` as const }
  return res
}

/**
 * @description Query topics by start time for timeline views.
 * @summary Query topics by time range
 * {@link /nlp-integration/v1/live-topics/:slug/topics}
 */
export async function nlpIntegrationQueryTopicsLiveTopics(slug: NlpIntegrationQueryTopicsLiveTopicsPathParams["slug"], params?: NlpIntegrationQueryTopicsLiveTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NlpIntegrationQueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<NlpIntegrationQueryTopicsLiveTopics401 | NlpIntegrationQueryTopicsLiveTopics403>, unknown>({ method : "GET", url : getNlpIntegrationQueryTopicsLiveTopicsUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}